"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNodeHighlighter = exports.highlightNodes = void 0;
const react_1 = require("react");
const throttle_1 = __importDefault(require("lodash/throttle"));
const constants_1 = require("../constants");
const DEBUG_REGEX = new RegExp(constants_1.DEBUG_REGEX_TEXT, 'g');
const DEBUG_INTL_ID_REGEX = new RegExp(constants_1.DEBUG_REGEX_TEXT);
/**
 * A function that walks the DOM tree and captures nodes that include the given text.
 * @param rootElement The element whose children should be searched for nodes
 * @param text The text to match nodes against
 * @returns nodes that match the text
 */
const findNodesByText = (rootElement, text) => {
    const filter = {
        acceptNode: function (node) {
            var _a;
            if (node.nodeType === document.TEXT_NODE && ((_a = node.nodeValue) === null || _a === void 0 ? void 0 : _a.match(text))) {
                return NodeFilter.FILTER_ACCEPT;
            }
            return NodeFilter.FILTER_REJECT;
        }
    };
    const nodes = [];
    const walker = document.createTreeWalker(rootElement, NodeFilter.SHOW_TEXT, filter);
    while (walker.nextNode()) {
        nodes.push(walker.currentNode.parentNode);
    }
    return nodes;
};
/**
 * A function creator for highlighting nodes in the DOM for debugging.
 *
 * @param rootElement The element whose children should be searched for nodes to highlight
 * @param text The text to match nodes against
 * @param intl The associated `IntlShape` object
 * @returns function that highlights nodes in the DOM
 */
const highlightNodes = (rootElement, text) => (0, throttle_1.default)(() => {
    const nodes = findNodesByText(rootElement, text);
    nodes.forEach((node) => {
        var _a, _b, _c;
        if (node) {
            node.style.whiteSpace = 'nowrap';
            node.style.outline = '2px solid red';
            node.style.outlineOffset = '0px';
            const content = (_a = node.textContent) !== null && _a !== void 0 ? _a : '';
            const { intlDebugId } = (_c = (_b = content.match(DEBUG_INTL_ID_REGEX)) === null || _b === void 0 ? void 0 : _b.groups) !== null && _c !== void 0 ? _c : {};
            if (intlDebugId != null) {
                node.dataset.intlDebugId = intlDebugId;
            }
        }
    });
}, 500);
exports.highlightNodes = highlightNodes;
/**
 * A hook for highlighting nodes in the DOM for debugging.
 *
 * This hook leverages the `MutationObserver` API to highlight nodes even if they were not in the initial render.
 *
 * @param runCondition A boolean value that determines whether to run the node highlighter
 * @param intl The associated `IntlShape` object
 */
const useNodeHighlighter = (runCondition) => {
    (0, react_1.useEffect)(() => {
        let observer;
        if (runCondition && (document === null || document === void 0 ? void 0 : document.body)) {
            // run once on mount, then observe for changes
            (0, exports.highlightNodes)(document.body, DEBUG_REGEX)();
            observer = new MutationObserver((0, exports.highlightNodes)(document.body, DEBUG_REGEX));
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
        return () => {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- intl shouldn't change
    }, [runCondition]);
};
exports.useNodeHighlighter = useNodeHighlighter;
//# sourceMappingURL=useNodeHighlighter.js.map